<template>
  <div class="con-wrap">
    <div>
      <el-form
        size="medium"
        :inline="true"
        :model="queryForm"
        ref="queryForm"
        class="input-form-inline"
        @submit.native.prevent
      >
        <div>
          <el-form-item class="r-20" prop="plate">
            <el-input
              v-model.trim="queryForm.plate"
              placeholder="请输入车牌号"
              @keyup.native.enter="query"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="scene">
            <el-select v-model="queryForm.scene" placeholder="反馈场景">
              <el-option
                v-for="item in scene"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="r-20" prop="handle">
            <el-select v-model="queryForm.handle" placeholder="反馈状态">
              <el-option
                v-for="item in handle"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button
            v-if="hasPerm('feedback:issue:list')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('feedback:issue:list')" @click="reset"
            >取消</el-button
          >
        </div>

        <div style="margin-bottom: 20px">
          <el-button
            size="medium"
            v-if="hasPerm('feedback:issue:update')"
            type="primary"
            @click="handleFeedback"
            >处理反馈</el-button
          >
          <el-button
            size="medium"
            v-if="hasPerm('feedback:issue:delete')"
            type="danger"
            @click="delFeedback"
            >删除</el-button
          >
        </div>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
        @row-click="handleClickTableRow"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="24"
          align="center"
          style="padding: 0"
        ></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="scene" label="反馈场景">
          <template slot-scope="scope">
            <span v-if="scope.row.scene == 1">车辆相关</span>
            <span v-else-if="scope.row.scene == 2">发电相关</span>
            <span v-else-if="scope.row.scene == 3">功能建议</span>
            <span v-else-if="scope.row.scene == 4">BUG反馈</span>
            <span v-else-if="scope.row.scene == 5">其他</span>
            <span v-else>数据改变，修改解析方式</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="personnelName"
          label="车辆绑定人"
        ></el-table-column>
        <el-table-column
          prop="vehicleModel"
          label="车辆型号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="vin"
          label="车架号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="plateNum"
          label="车牌号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="addTime"
          label="反馈时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="handle" label="反馈状态">
          <template slot-scope="scope">
            <span v-if="scope.row.handle == 1" class="btn-orange">未处理</span>
            <span v-else-if="scope.row.handle == 2" class="btn-green"
              >已处理</span
            >
            <span v-else>数据改变，修改解析方式</span>
          </template>
        </el-table-column>
        <el-table-column prop="replaceTime" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('feedback:issue:list')"
              @click.stop="getFeedbackInfo(scope.row)"
              >反馈内容</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <!--处理反馈-->
      <el-dialog
        title="处理反馈"
        :visible.sync="handleVisible"
        class="feedback-dialog"
      >
        <el-form
          ref="feedbackForm"
          :model="feedbackForm"
          size="mini"
          :inline="true"
        >
          <el-form-item label="反馈场景">
            {{ dialogScene }}
          </el-form-item>
          <el-form-item prop="feedbackCon" label="反馈内容">
            <el-input
              type="textarea"
              v-model="feedbackCon"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item prop="feedbackCon" label="反馈图片">
            <el-image
              style="width: 100px; height: 100px;margin-right:10px;"
              v-for="url in urls"
              :key="url"
              :src="url"
              :zIndex="3000"
              :preview-src-list="urls"
              @click.stop="handleClickItem"
            >
            </el-image>
          </el-form-item>
          <el-form-item prop="handleMethod" label="处理方法">
            <el-input
              type="textarea"
              v-model="feedbackForm.handleMethod"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item prop="handle" label="处理状态">
            <el-select v-model="feedbackForm.handle" placeholder="请选择">
              <el-option
                v-for="item in handle"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 反馈内容 -->
      <el-dialog
        title="反馈摘要"
        :visible.sync="conVisible"
        class="mini-dialog info-box"
      >
        <el-row :gutter="20">
          <el-col :span="4" class="dialog-label">反馈场景</el-col>
          <el-col :span="20">{{ infoScene }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" class="dialog-label">反馈内容</el-col>
          <el-col :span="20">{{ infoCon }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" class="dialog-label">反馈图片</el-col>
          <el-col :span="20">
            <el-image
              style="width: 100px; height: 100px;margin-right:10px;"
              v-for="url in urls"
              :key="url"
              :src="url"
              :zIndex="3000"
              :preview-src-list="urls"
              @click.stop="handleClickItem"
            >
            </el-image>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" class="dialog-label">处理方法</el-col>
          <el-col :span="20">{{ infoMethod }}</el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="conVisible = false">取 消</el-button>
          <el-button type="primary" @click="conVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        scene: "",
        handle: "",
      },
      scene: [
        {
          id: 1,
          label: "车辆相关",
        },
        {
          id: 2,
          label: "发电相关",
        },
        {
          id: 3,
          label: "功能建议",
        },
        {
          id: 4,
          label: "BUG反馈",
        },
        {
          id: 5,
          label: "其他",
        },
      ],
      handle: [
        {
          id: 1,
          label: "未处理",
        },
        {
          id: 2,
          label: "已处理",
        },
      ],
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      handleVisible: false,
      dialogScene: "",
      feedbackForm: {
        handleMethod: "",
        handle: "",
      },
      feedbackCon: "",
      conVisible: false,
      infoScene: "",
      infoCon: "",
      infoMethod: "",
      urls: [],
      type: 2,
    };
  },
  created() {
    this.getFeedbackList();
  },
  methods: {
    async getFeedbackList() {
      let _this = this;
      let obj = {};
      obj.type = _this.type;
      obj.plate = _this.queryForm.plate;
      obj.scene = _this.queryForm.scene;
      obj.handle = _this.queryForm.handle;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/feedback/issue/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    query() {
      this.getFeedbackList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getFeedbackList();
    },
    delFeedback() {
      let _this = this;
      //多选删除
      let ids = _this.$getIds(_this.tableVal);
      if (!ids) {
        return;
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/feedback/issue", {
            data: JSON.stringify(ids),
          });
          if (res.code == 1) {
            _this.$message.success("操作成功");
            let totalPage = Math.ceil((_this.total - 1) / 10);
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage;
            _this.currentPage = currentPage < 1 ? 1 : currentPage;
            _this.getFeedbackList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    getFeedbackInfo(rowData) {
      this.urls = [];
      if (rowData.scene == 1) {
        this.infoScene = "车辆相关";
      } else if (rowData.scene == 2) {
        this.infoScene = "发电相关";
      } else if (rowData.scene == 3) {
        this.infoScene = "功能建议";
      } else if (rowData.scene == 4) {
        this.infoScene = "BUG反馈";
      } else if (rowData.scene == 5) {
        this.infoScene = "其他";
      }
      this.infoCon = rowData.content;
      this.infoMethod = rowData.handleMethod;
      if (rowData.imageUrl != "") {
        this.urls = rowData.imageUrl;
      }
      this.conVisible = true;
    },
    handleFeedback() {
      this.$resetForm(this, "feedbackForm");
      this.urls = [];
      let _this = this;
      if (this.tableVal.length > 1) {
        this.$message.warning("一次只能处理一条数据");
        return;
      }
      let ids = _this.$getIds(_this.tableVal);
      if (!ids) {
        return;
      }
      this.handleVisible = true;
      this.dialogScene = _this.tableVal[0].scene;
      if (this.dialogScene == 1) {
        this.dialogScene = "车辆相关";
      } else if (this.dialogScene == 2) {
        this.dialogScene = "发电相关";
      } else if (this.dialogScene == 3) {
        this.dialogScene = "功能建议";
      } else if (this.dialogScene == 4) {
        this.dialogScene = "BUG反馈";
      } else if (this.dialogScene == 5) {
        this.dialogScene = "其他";
      }
      this.feedbackCon = _this.tableVal[0].content;
      this.urls = _this.tableVal[0].imageUrl;
    },
    async saveOrUpdate() {
      let _this = this;
      let parm = {
        handle: _this.feedbackForm.handle,
        handleMethod: _this.feedbackForm.handleMethod,
        id: _this.tableVal[0].id,
      };
      let { data: res } = await _this.$axios.patch("/api/feedback/issue", parm);
      if (res.code == 1) {
        _this.$message.success("操作成功");
        _this.getFeedbackList();
      } else {
        _this.$message.warning(res.msg);
      }
      _this.handleVisible = false;
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getFeedbackList();
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
.feedback-dialog /deep/ {
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
  .el-form-item__content {
    width: 420px;
    height: auto;
  }
  .el-form-item__label {
    width: 120px;
    height: 32px;
    margin-left: 20px;
    text-align: left;
    color: #343434;
    font-size: 14px;
  }
  .el-dialog {
    width: 620px;
  }
}
.info-box /deep/ {
  .el-dialog__body {
    color: #333;
    padding-left: 40px;
  }
  .el-dialog__footer {
    padding-top: 10px;
  }
  .el-row {
    line-height: 34px;
  }
}
.dialog-label {
  padding-left: 20px;
  font-weight: bold;
}
</style>
